import { CircularProgress } from '@material-ui/core';
import React, { Component } from 'react';
import { Accordion } from 'react-bootstrap';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { store } from 'react-notifications-component';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import chatIcon from '../../../Assets/images/Activation/needHelp.svg';
import helpPortIcon from '../../../Assets/images/Activation/helpPortIcon.svg';
import BackButton from '../../../Assets/images/commonImages/backButton.svg';
import Button from '../../../components/Button/Button';
// import Select from '../../../components/SelectDropDown/SelectDropDown';
import TextField from '../../../components/Textfield/TextField';
import { configPayload, isPaymentEnabled } from '../../../config';
// import {  pushTrackingEventsToGAAndFBNew } from '../../../global/commonFunctions/GaAndFb';
import { globalVal } from '../../../global/globalvalues';
import { activationPage } from '../../../global/texts/postActivation/activation';
import * as ActivationAction from '../../../store/Activation/actions';
import * as BillingAction from '../../../store/Billing/actions';
import * as Action from '../../../store/Checkout/actions';
import * as HomeAction from '../../../store/HomePage/actions';
import * as PostActivationAction from '../../../store/PostActivation/actions';
import firebase from '../../../utils/firebase';
import './Steps.scss';
import TagManager from 'react-gtm-module';
import { getUserName } from '../../../global/commonFunctions/getUserName';
import { SearchBoxWithDropdown } from '../../../components/SearchBox/SearchBox';

type initialProps = {
    history: any;
    changeCurrentPage?: any;
    CheckoutActions: any;
    CheckoutState: any;
    ActivationActions: any;
    BillingActions: any;
    BillingState: any;
    ActivationState: any;
    homeAction: any;
    homeState: any;
    PostActivationAction: any;
    PostActivationState: any;
    showStep3?: any;
    fromAddLine?: any;
    goBackHandler?: any;
    simSwapInProgress?:boolean;
};
type initialState = {
    isFormData: boolean;
    isShowZipModal: boolean;
    zipcode: string;
    checkZipcodeClicked: boolean;
    phone: string;
    carrier: any;
    zipcode1: string;
    accountNumber: string;
    pin: string;
    carrierList: any;
    phoneErr: string;
    carrierErr: string;
    otherCarrierErr: string;
    zipErr: string;
    accountNumberErr: string;
    pinErr: string;
    customerData: any;
    zipErr1: string;
    nextClicked: boolean;
    otherCarrier: string;
    user: any;
    secondaryUser: any;
    eSim: boolean;
    loader: boolean;
    portJourney: boolean;
    currentUser: any;
    portValidated: boolean;
    phoneLength: number;
    faqUrl: any;
    filteredCarrierList: any;
};
export class Step2 extends Component<initialProps, initialState> {
    state: initialState = {
        isFormData: false,
        isShowZipModal: false,
        zipcode: '',
        checkZipcodeClicked: false,
        phone: '',
        carrier: 'Select carrier',
        zipcode1: '',
        accountNumber: '',
        pin: '',
        phoneErr: '',
        carrierErr: '',
        otherCarrierErr: '',
        zipErr: '',
        accountNumberErr: '',
        pinErr: '',
        customerData: [],
        zipErr1: '',
        carrierList: [],
        nextClicked: false,
        otherCarrier: '',
        user: '',
        secondaryUser: '',
        eSim: false,
        loader: false,
        portJourney: false,
        currentUser: '',
        portValidated: false,
        phoneLength: 0,
        faqUrl: '',
        filteredCarrierList: [],
    };
    async componentDidMount() {
        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryCustomer = JSON.parse(secondaryCustomer);
        let currentdetails: any = localStorage.getItem('customerDetail');
        currentdetails = JSON.parse(currentdetails);
        this.removeAllTickers();

        let user1: any = localStorage.getItem('currentuser');
        user1 = JSON.parse(user1);
        let email: string = user1 && user1.email ? user1.email : '';
        this.setState({ user: currentdetails, secondaryUser: secondaryCustomer });
        if (secondaryCustomer) {
            this.setState({ eSim: secondaryCustomer.esim, currentUser: secondaryCustomer });
        } else {
            this.setState({ eSim: currentdetails.esim, currentUser: currentdetails });
        }
        this.props.ActivationActions.getAppData();
        this.props.BillingActions.config(configPayload);
        if (isPaymentEnabled) {
            const carrierList = await firebase.database().ref('operators/');
            carrierList.on('value', (snapshot: any) => {
                const data = snapshot.val();
                if (data) {
                    let data1: any = [];
                    data.map((el: any) => {
                        return data1.push({
                            ...el,
                            value: el.displayName,
                            label: el.displayName,
                            displayName: el.displayName,
                        });
                    });
                    if (secondaryCustomer) {
                        if (
                            this.props.PostActivationState &&
                            this.props.PostActivationState.group &&
                            this.props.PostActivationState.group.data &&
                            this.props.PostActivationState.group.data.length > 0
                        ) {
                            const data = this.props.PostActivationState.group.data.find(
                                (item: { id: any }) => item.id === secondaryCustomer.id,
                            );

                            // this.setState({
                            //     customerData: data,
                            // });
                            if (data.zipcode) {
                                this.setState({
                                    zipcode: data.zipcode,
                                });
                            }
                            let carrier = data1.find((it: any) => data.mnpInfo && it.value === data.mnpInfo.operator);
                            if (data.mnpInfo) {
                                this.setState({
                                    phone: data.mnpInfo.oldNumber ? data.mnpInfo.oldNumber : '',
                                    carrier: carrier ? carrier : null,
                                    zipcode1: data.mnpInfo.oldZip ? data.mnpInfo.oldZip : '',
                                    accountNumber: data.mnpInfo.acctNum ? data.mnpInfo.acctNum : '',
                                    pin: data.mnpInfo.oldPassword ? data.mnpInfo.oldPassword : '',
                                });
                            }
                        } else {
                            this.props.PostActivationAction.customerGroup({
                                groupId: currentdetails && currentdetails.groupId,
                            });
                        }
                    } else if (
                        this.props.CheckoutState.getCustomer &&
                        this.props.CheckoutState.getCustomer.status === 'SUCCESS' &&
                        this.props.CheckoutState.getCustomer.data
                    ) {
                        const data: any = this.props.CheckoutState.getCustomer.data;
                        // this.setState({
                        //     customerData: data,
                        // });
                        if (data.zipcode) {
                            this.setState({
                                zipcode: data.zipcode,
                            });
                        }
                        let carrier = data1.find((it: any) => data.mnpInfo && it.value === data.mnpInfo.operator);
                        if (data.mnpInfo) {
                            this.setState({
                                phone: data.mnpInfo.oldNumber ? data.mnpInfo.oldNumber : '',
                                carrier: carrier ? carrier : null,
                                zipcode1: data.mnpInfo.oldZip ? data.mnpInfo.oldZip : '',
                                accountNumber: data.mnpInfo.acctNum ? data.mnpInfo.acctNum : '',
                                pin: data.mnpInfo.oldPassword ? data.mnpInfo.oldPassword : '',
                            });
                        }
                    } else {
                        email &&
                            this.props.CheckoutActions.GetCustomer({
                                username: encodeURIComponent(email),
                            });
                    }
                    // data1.push({
                    //     value: 'Other',
                    //     label: 'Other',
                    // });
                    this.setState({
                        carrierList: data1,
                        filteredCarrierList: data1,
                    });
                }
            });
        }
    }

    componentWillUnmount() {
        this.removeAllTickers();
    }

    removeAllTickers() {
        store.removeNotification('activationInvalidNumberFail');
        store.removeNotification('activationPortResultFail');
        store.removeNotification('activationPostError');
        store.removeNotification('activationPostErrorDefault');
    }

    componentDidUpdate(prevProps: initialProps) {
        let cur = this.props && this.props.CheckoutState;
        let prev = prevProps && prevProps.CheckoutState;
        let curH = this.props && this.props.homeState;
        let prevH = prevProps && prevProps.homeState;
        let curA = this.props && this.props.ActivationState;
        let prevA = prevProps && prevProps.ActivationState;
        let curPA = this.props && this.props.PostActivationState;
        let prevPA = prevProps && prevProps.PostActivationState;
        let curB = this.props && this.props.BillingState;
        let prevB = prevProps && prevProps.BillingState;
        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryCustomer = JSON.parse(secondaryCustomer);

        if (prevB.config !== curB.config && curB.config && curB.config.status === 'SUCCESS' && curB.config.data) {
            this.setState({ faqUrl: curB.config.data?.configs?.FAQ_LINK });
        }
        if (
            prevA.getAppData !== curA.getAppData &&
            curA.getAppData &&
            curA.getAppData.status === 'SUCCESS' &&
            curA.getAppData.data
        ) {
            let data1: any = [];
            curA.getAppData.data.operators.map((el: any) => {
                return data1.push({
                    ...el,
                    value: el.displayName,
                    label: el.displayName,
                    displayName: el.displayName,
                });
            });

            // data1.push({
            //     value: 'Other',
            //     label: 'Other',
            // });
            this.setState({
                carrierList: data1,
                filteredCarrierList: data1,
            });
        }
        if (secondaryCustomer) {
            if (
                prevPA.group !== curPA.group &&
                curPA.group &&
                curPA.group.status === 'SUCCESS' &&
                curPA.group.data &&
                curPA.group.data.length > 0
            ) {
                const data = this.props.PostActivationState.group.data.find(
                    (item: { id: any }) => item.id === secondaryCustomer.id,
                );
                this.setState({
                    currentUser: data,
                });
                if (data.zipcode) {
                    this.setState({
                        zipcode: data.zipcode,
                    });
                }
                let carrier =
                    this.state.carrierList &&
                    this.state.carrierList.find(
                        (it: any) => data.mnpInfo && data.mnpInfo.operator && it.value === data.mnpInfo.operator,
                    );
                if (data.mnpInfo) {
                    this.setState({
                        phone: data.mnpInfo.oldNumber ? data.mnpInfo.oldNumber : '',
                        carrier: carrier ? carrier : null,
                        zipcode1: data.mnpInfo.oldZip ? data.mnpInfo.oldZip : '',
                        accountNumber: data.mnpInfo.acctNum ? data.mnpInfo.acctNum : '',
                        pin: data.mnpInfo.oldPassword ? data.mnpInfo.oldPassword : '',
                    });
                }
            }
        } else if (
            prev.getCustomer !== cur.getCustomer &&
            cur.getCustomer &&
            cur.getCustomer.status === 'SUCCESS' &&
            cur.getCustomer.data
        ) {
            const data: any = cur.getCustomer.data;
            this.setState({
                currentUser: data,
            });
            if (data.zipcode) {
                this.setState({
                    zipcode: data.zipcode,
                });
            }
            let carrier =
                this.state.carrierList &&
                this.state.carrierList.find(
                    (it: any) => data.mnpInfo && data.mnpInfo.operator && it.value === data.mnpInfo.operator,
                );

            if (data.mnpInfo) {
                this.setState({
                    phone: data.mnpInfo.oldNumber ? data.mnpInfo.oldNumber : '',
                    carrier: carrier ? carrier : null,
                    zipcode1: data.mnpInfo.oldZip ? data.mnpInfo.oldZip : '',
                    accountNumber: data.mnpInfo.acctNum ? data.mnpInfo.acctNum : '',
                    pin: data.mnpInfo.oldPassword ? data.mnpInfo.oldPassword : '',
                });
            }
        }
        if (prevH.coveragePlans !== curH.coveragePlans && curH.coveragePlans) {
            if (curH.coveragePlans.data && curH.coveragePlans.status === 'SUCCESS' && curH.coveragePlans.data.isValid) {
                this.props.CheckoutActions.UpdateCustomerSource({
                    // customerId: this.state.customerData && this.state.customerData.id,
                    customerId: this.state.secondaryUser ? this.state.secondaryUser?.id : this.state.user?.id,
                    data: { zipcode: this.state.zipcode },
                });
                this.setState({
                    isShowZipModal: true,
                    checkZipcodeClicked: false,
                });
                let customerDetail: any = localStorage.getItem('customerDetail');
                customerDetail = JSON.parse(customerDetail);

                if (this.props.fromAddLine) {
                    this.props.showStep3();
                    this.setState({
                        isShowZipModal: false,
                    });
                } else if (secondaryCustomer) {
                    if (secondaryCustomer?.esim) {
                        this.setState({
                            isShowZipModal: false,
                        });
                        this.props.changeCurrentPage('Step3');
                    } else {
                        this.props.changeCurrentPage('Step3');
                    }
                } else {
                    this.props.changeCurrentPage('Step3');
                    // if (customerDetail.esim) {
                    // } else {
                    //     this.props.changeCurrentPage('Step3');
                    // }
                }
            } else if (
                curH.coveragePlans.data &&
                curH.coveragePlans.status === 'SUCCESS' &&
                !curH.coveragePlans.data.isValid
            ) {
                this.setState({
                    checkZipcodeClicked: false,
                    zipErr1: 'Invalid ZIP code. Please retry with a valid ZIP code.',
                });
            } else {
                this.setState({
                    checkZipcodeClicked: false,
                    zipErr1: activationPage.errorDefault,
                });
            }
        }
        if (
            prev.updateCustomerSource !== cur.updateCustomerSource &&
            cur.updateCustomerSource &&
            cur.updateCustomerSource.status === 'SUCCESS' &&
            this.state.portValidated
        ) {
            this.setState({
                nextClicked: false,
            });
            setTimeout(() => {
                this.props.changeCurrentPage('Step3');
            }, 100);
        }
        if (
            prevA.portResult !== curA.portResult &&
            curA.portResult &&
            curA.portResult.status === 'SUCCESS' &&
            curA.portResult.data
        ) {
            if (curA.portResult.data.isPortValidate) {
                this.setState({ portValidated: true });
                this.props.CheckoutActions.UpdateCustomerSource({
                    customerId: this.state.currentUser && this.state.currentUser.id,
                    data: {
                        mnpInfo: {
                            oldNumber: this.state.phone.replace(/(\D)/g, ''),
                            operator:
                                this.state.carrier.displayName === 'Other'
                                    ? this.state.otherCarrier
                                    : this.state.carrier.displayName,
                            oldZip: this.state.zipcode1,
                            acctNum: this.state.accountNumber,
                            oldPassword: this.state.pin,
                        },
                    },
                });
                localStorage.setItem('fromPorting', JSON.stringify(true));
            } else {
                this.setState({
                    nextClicked: false,
                });
                window.scroll(0, 0);
                store.addNotification({
                    message: activationPage.errorPortValidate,
                    type: 'danger',
                    insert: 'top',
                    container: 'top-full',
                    animationIn: ['animate__animated', 'animate__fadeIn'],
                    animationOut: ['animate__animated', 'animate__fadeOut'],
                    dismiss: {
                        duration: 5000,
                        showIcon: true,
                    },
                    id: 'activationInvalidNumberFail',
                });
            }
        }
        if (
            prevA.errorPortResult !== curA.errorPortResult &&
            curA.errorPortResult &&
            curA.errorPortResult.status === 'FAILURE'
        ) {
            this.setState({
                nextClicked: false,
            });
            window.scroll(0, 0);
            store.addNotification({
                message: activationPage.errorDefault,
                type: 'danger',
                insert: 'top',
                container: 'top-full',
                animationIn: ['animate__animated', 'animate__fadeIn'],
                animationOut: ['animate__animated', 'animate__fadeOut'],
                dismiss: {
                    duration: 5000,
                    showIcon: true,
                },
                id: 'activationPortResultFail',
            });
        }
        if (prevA.port !== curA.port && curA.port && curA.port.status === 'SUCCESS' && curA.port.data) {
            this.props.ActivationActions.portResult({
                data: curA.port.data,
            });
        }
        if (
            prevA.errorPort !== curA.errorPort &&
            curA.errorPort &&
            curA.errorPort.status === 'FAILURE'
            // && curA.errorPort.resCode
        ) {
            this.setState({
                nextClicked: false,
            });
            if (curA.errorPort.resCode === 40227) {
                window.scroll(0, 0);
                store.addNotification({
                    message: curA.errorPort.message,
                    type: 'danger',
                    insert: 'top',
                    container: 'top-full',
                    animationIn: ['animate__animated', 'animate__fadeIn'],
                    animationOut: ['animate__animated', 'animate__fadeOut'],
                    dismiss: {
                        duration: 5000,
                        showIcon: true,
                    },
                    id: 'activationPostError',
                });
            } else if (curA.errorPort.resCode === 40093) {
                window.scroll(0, 0);
                store.addNotification({
                    message: 'Number is not portable',
                    type: 'danger',
                    insert: 'top',
                    container: 'top-full',
                    animationIn: ['animate__animated', 'animate__fadeIn'],
                    animationOut: ['animate__animated', 'animate__fadeOut'],
                    dismiss: {
                        duration: 5000,
                        showIcon: true,
                    },
                    id: 'activationPostError',
                });
            } else {
                window.scroll(0, 0);
                store.addNotification({
                    message: activationPage.errorDefault,
                    type: 'danger',
                    insert: 'top',
                    container: 'top-full',
                    animationIn: ['animate__animated', 'animate__fadeIn'],
                    animationOut: ['animate__animated', 'animate__fadeOut'],
                    dismiss: {
                        duration: 5000,
                        showIcon: true,
                    },
                    id: 'activationPostErrorDefault',
                });
            }
        }
    }
    keepMyButtonHandler = () => {
        let customerDetails: any = localStorage.getItem('customerDetail');
        customerDetails = JSON.parse(customerDetails);
        let occurence = this.state.currentUser.peerAccountRef.split('|')[2];
        TagManager.dataLayer({
            dataLayer: {
                event: 'Current_Number',
                accountNo: customerDetails?.meta?.customer_statement_number,
                line_number: occurence,
            },
        });
        // this.GAAndFBEventsHandler("Current_Number",customerDetails?.meta?.customer_statement_number, occurence)
        this.props.CheckoutActions.UpdateCustomerSource({
            customerId: this.state.currentUser && this.state.currentUser.id,
            data: { isMNP: true },
        });
        this.setState({
            isFormData: true,
            portJourney: true,
        });
    };
    // GAAndFBEventsHandler = (buttonVal: string, accNumber?: any, lineNumber?:any, size?:any) => {
    //     pushTrackingEventsToGAAndFBNew("event", buttonVal, {
    //       screenName: "home",
    //       buttonValue: buttonVal,
    //       accNumber: accNumber,
    //       lineNumber: lineNumber,
    //       data: size,
    //     });
    //   };
    getANewNumberHandler = () => {
        let customerDetails: any = localStorage.getItem('customerDetail');
        customerDetails = JSON.parse(customerDetails);
        let occurence = this.state.currentUser.peerAccountRef.split('|')[2];
        TagManager.dataLayer({
            dataLayer: {
                event: 'New_Number',
                accountNo: customerDetails?.meta?.customer_statement_number,
                line_number: occurence,
            },
        });
        // this.GAAndFBEventsHandler("New_Number",customerDetails?.meta?.customer_statement_number,occurence)
        if (this.state.currentUser && this.state.currentUser.id) {
            this.props.CheckoutActions.UpdateCustomerSource({
                customerId: this.state.currentUser && this.state.currentUser.id,
                data: { isMNP: false },
            });
        }
        this.setState({
            isShowZipModal: true,
        });
    };
    onHide = () => {
        this.setState({ isShowZipModal: false, zipErr1: '', checkZipcodeClicked: false });
    };
    zipcodeHandler = (e: any) => {
        this.setState({ zipcode: e.target.value, zipErr1: '' });
    };
    carrierHandler = (e: any) => {
        if(!e) {
            this.setState({
                carrier: e,
            });
            return;
        }
        let carrier1: any = this.state.carrierList.find((e1: any) => e1.displayName === e?.displayName);
        if (carrier1) {
            this.setState({ carrier: carrier1 });
        } else {
            this.setState({
                carrier: {
                    value: e,
                    label: 'Other',
                    displayName: 'Other'
                },
            });
        }
    };
    onChangeHandler = async (e: any, name: string) => {
        this.setState({ ...this.state, [name]: e.target.value });
        if (name === 'zipcode1') {
            this.setState({
                zipErr: '',
            });
        } else if (name === 'accountNumber') {
            this.setState({
                accountNumberErr: '',
            });
        } else if (name === 'phone' && (/^[0-9]+$/.test(e.target.value) || e.target.value === '')) {
            let number = e.target.value;
            this.setState({ phoneLength: number.length });
            if (number.length === 10 && /^\d+$/.test(number)) {
                number = await this.formatPhoneNumber(number);
            }
            this.setState({
                phoneErr: '',
                phone: number,
            });
        } else if (name === 'carrier') {
            this.carrierHandler(e.target.value);
            this.setState({
                carrierErr: '',
            });
        } else if (name === 'pin') {
            this.setState({
                pinErr: '',
            });
        } else if (name === 'others') {
            this.setState({
                otherCarrier: e.target.value,
                otherCarrierErr: '',
            });
        }
    };
    checkZipcodeHandler = () => {
        if (this.state.zipcode && /^\d{5,10}$/.test(this.state.zipcode)) {
            this.setState({
                checkZipcodeClicked: true,
            });
            this.props.homeAction.coveragePlans({
                zipcode: this.state.zipcode,
            });
            let customerDetails: any = localStorage.getItem('customerDetail');
            customerDetails = JSON.parse(customerDetails);
            let occurence = this.state.currentUser.peerAccountRef.split('|')[2];
            TagManager.dataLayer({
                dataLayer: {
                    event: 'ZipCheck',
                    accountNo: customerDetails?.meta?.customer_statement_number,
                    line_number: occurence,
                    ZIP_Code: this.state.zipcode,
                },
            });
            // this.GAAndFBEventsHandler("ZipCheck",customerDetails?.meta?.customer_statement_number,occurence, this.state.zipcode);
        }
    };
    nextHandler = () => {
        // this.setState({
        //     carrier: {
        //         ...this.state.carrier,
        //         value: this.state.otherCarrier,
        //     },
        // });
        if (
            this.state.zipcode1 &&
            /(^\d{5}$)|(^\d{5,10}$)/.test(this.state.zipcode1) &&
            // /^\d{5,10}$/.test(this.state.zipcode1) &&
            // /(^\d{5}$)|(^\d{5,10}$)/.test(this.state.zipcode1) &&
            this.state.carrier &&
            this.state.accountNumber !== '' &&
            (this.state.carrier === 'Other' ? this.state.otherCarrier : true) &&
            this.state.phone !== '' &&
            this.state.phone.length === 14 &&
            this.state.pin !== ''
        ) {
            this.setState({
                nextClicked: true,
            });
            let numb: any = this.state.phone.match(/\d/g);
            let numb1: number = parseInt(numb.join(''));
            this.props.ActivationActions.port({
                countryCode: 'USA',
                number: numb1,
                isPrimary: this.state.currentUser && this.state.currentUser.isPrimary,
            });
        } else {
            if (this.state.zipcode1 === '') {
                this.setState({
                    zipErr: 'Zip code cannot be empty',
                });
            } else if (!/^\d{5,10}$/.test(this.state.zipcode1)) {
            } else if (!/(^\d{5}$)|(^\d{5,10}$)/.test(this.state.zipcode1)) {
                this.setState({
                    zipErr: 'Enter valid zip code',
                });
            }
            if (this.state.accountNumber === '') {
                this.setState({
                    accountNumberErr: 'Account number cannot be empty',
                });
            }
            if (this.state.phone === '') {
                this.setState({
                    phoneErr: 'Phone number cannot be empty',
                });
            } else if (!/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s.]{0,1}[0-9]{3}[-\s.]{0,1}[0-9]{4}$/.test(this.state.phone)) {
                this.setState({
                    phoneErr: 'Phone number should be 10 digits long.',
                });
            }
            if (!this.state.carrier) {
                this.setState({
                    carrierErr: 'Please select an operator',
                });
            }
            if (this.state.pin === '') {
                this.setState({
                    pinErr:
                        'PIN is an optional input. However, if you have a PIN, please enter the value (15 characters or fewer; containing only letters and numbers)',
                });
            }
            if (this.state.carrier && this.state.carrier.label === 'Other' && this.state.otherCarrier === '') {
                this.setState({
                    otherCarrierErr: 'Please enter carrier name',
                });
            }
        }
    };
    formatPhoneNumber = (phone: string) => {
        var cleaned = ('' + phone).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            var intlCode = match[1] ? '+1 ' : '';
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return null;
    };
    backHandler = () => {
        if (this.state.isFormData) {
            this.setState({
                isFormData: false,
            });
        } else {
            if (this.props.fromAddLine) {
                localStorage.removeItem('simPreference');
                this.props.goBackHandler();
            } else {
                let user1: any = localStorage.getItem('currentuser');
                user1 = JSON.parse(user1);
                let email: string = user1 && user1.email ? user1.email : '';
                email &&
                    this.props.CheckoutActions.GetCustomer({
                        username: encodeURIComponent(email),
                    });
                this.props.changeCurrentPage('Step1');
            }
        }
        if (this.state.portJourney) {
            this.setState({ portJourney: false });
        }
    };
    searchChangeHandle = (event: any, val: any) => {
        console.log(event)
        this.carrierHandler(val);
    }

    carrierOnChange = (e:any) => {
        const data: any = 
            this.state.carrierList.filter((item: any) => 
                item.displayName.toLowerCase().includes(e.target.value.toLowerCase()));
        if(data.length === 0) {
            this.setState({
                filteredCarrierList: [
                    {label: "Other", value: "Other", displayName: 'Other'}
                ]
            })
        } else {
            this.setState({
                filteredCarrierList: data,
            })
        }
    }
    render() {
        const {
            isFormData,
            isShowZipModal,
            zipcode,
            checkZipcodeClicked,
            phone,
            carrier,
            zipcode1,
            accountNumber,
            pin,
            // carrierList,
            zipErr1,
            nextClicked,
            otherCarrier,
            // portJourney
        } = this.state;
        let primaryUser: any = localStorage.getItem('customerDetail');
        primaryUser = JSON.parse(primaryUser);
        let secondaryUser: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryUser = JSON.parse(secondaryUser);
        // let currentPlan: any = localStorage.getItem('currentPlan');
        // currentPlan = JSON.parse(currentPlan);
        // let esim: boolean = false;
        // if (secondaryUser) {
        //     esim = secondaryUser?.esim;
        // } else {
        //     esim = primaryUser?.esim;
        // }
        return (
            <div>
                <div className="backButtonActivation">
                    <img src={BackButton} alt="back" className="arrow_icon" onClick={this.backHandler} />
                    <div className="titleMainActivation">
                        {isFormData
                            ? activationPage.step2 && activationPage.step2.otherTitle
                            : isShowZipModal
                            ? 'Get a New Number'
                            : activationPage.step2 && activationPage.step2.title}
                    </div>
                </div>

                <div className="ProgressBarActivation">
                    <div className="stepsCount">{`Step 2 of ${this.state.currentUser?.esim ? '3' : '4'}`}</div>
                    <ProgressBar
                        variant="success"
                        now={this.state.currentUser?.esim ? 66 : 50}
                        className="progressBar"
                    />
                </div>

                <div className="step2Activation">
                    <div className="activationBox">
                        {!isFormData && !isShowZipModal ? (
                            <div className="numberPrefDiv">
                                <div className="keepMyButton">
                                    <div className="numPrefTitle">
                                        {getUserName()}{' '}
                                        needs a new number
                                    </div>
                                    <div className="numPrefSubtitle">
                                        It's time for a change! Let's get{' '}
                                        {getUserName()}{' '}
                                        a new number. The number will be assigned based on the ZIP code you choose.
                                    </div>
                                    <Button className="numPrefCTA" primary={true} onClick={this.getANewNumberHandler}
                                        disabled={this.props.simSwapInProgress}
                                    >
                                        Get a New Number
                                    </Button>
                                </div>
                                <div className="verticalLine"></div>
                                <div className="keepMyButton">
                                    <div className="numPrefTitle">
                                        Port in{' '}
                                        {getUserName()}
                                        's current number
                                    </div>
                                    <div className="numPrefSubtitle">
                                        We'll require some details from you to contact{' '}
                                        {getUserName()}
                                        's carrier about bringing their number over and getting them started on{' '}
                                        {globalVal.long_name}!
                                    </div>
                                    <Button className="numPrefCTA" primary={true} onClick={this.keepMyButtonHandler}>
                                        Keep Current Number
                                    </Button>
                                </div>
                            </div>
                        ) : isShowZipModal ? (
                            <div className="Step2">
                                <div className="activationModalHeading">
                                    Enter{' '}
                                    {getUserName()}
                                    's ZIP code
                                </div>
                                <div className="activationZipModalText">
                                    {getUserName()}
                                    's new number will be assigned based on the ZIP <br /> code you choose.
                                </div>
                                <div className="InputField">
                                    <div className="textFieldHead">ZIP CODE</div>
                                    <TextField
                                        value={zipcode}
                                        type="text"
                                        maxlength={10}
                                        // label="Enter your billing zip code"
                                        onChange={(e: any) => {
                                            if (/^[0-9]+$/.test(e.target.value) || e.target.value === '') {
                                                this.zipcodeHandler(e);
                                            }
                                        }}
                                        error={
                                            zipErr1 !== '' ||
                                            (zipcode !== '' && (zipcode === '00000' || zipcode === '99999')) ||
                                            (zipcode !== '' && !/^\d{5,10}$/.test(zipcode))
                                        }
                                        // helperText={
                                        //     zipErr1
                                        //         ? zipErr1
                                        //         : zipcode !== '' && (zipcode === '00000' || zipcode === '99999')
                                        //         ? 'Invalid ZIP code. Please retry with a valid ZIP code.'
                                        //         : checkZipcodeClicked && !zipcode
                                        //         ? 'Enter your billing zip code'
                                        //         : zipcode !== '' && !/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipcode)
                                        //         ? 'Invalid ZIP code. Please retry with a valid ZIP code.    '
                                        //         : ''
                                        // }
                                    />

                                    {/* <div className="limit-div">
                                        {zipcode && zipcode.length ? zipcode.length : '0'}
                                        /5
                                    </div> */}
                                    <div className="zipCodeError">
                                        {zipErr1
                                            ? zipErr1
                                            : zipcode !== '' && (zipcode === '00000' || zipcode === '99999')
                                            ? 'Invalid ZIP code. Please retry with a valid ZIP code.'
                                            : checkZipcodeClicked && !zipcode
                                            ? 'Enter your billing zip code'
                                            : zipcode !== '' && !/^\d{5,10}$/.test(zipcode)
                                            ? 'Invalid ZIP code. Please retry with a valid ZIP code.    '
                                            : ''}
                                    </div>
                                </div>
                                <div className="zip-button">
                                    <Button
                                        primary={true}
                                        onClick={!checkZipcodeClicked ? this.checkZipcodeHandler : ()=>{}}
                                        disabled={zipcode.length < 5 ? true : false}
                                    >
                                        {checkZipcodeClicked ? (
                                            <div className="loaderCheck text-center">
                                                <CircularProgress />
                                            </div>
                                        ) : (
                                            'Next'
                                        )}
                                    </Button>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div className="actPortingHeading">
                                    Enter {getUserName()}'s previous
                                    carrier account information below:
                                </div>
                                <div className="actPortingText">
                                    We’ll use this to contact their previous carrier about bringing the number over and
                                    getting {getUserName()}'s line
                                    started on {globalVal && globalVal.long_name}.
                                </div>
                                <div className="InputFields">
                                    <div className="inputFieldLabel">Previous Phone Number</div>
                                    <TextField
                                        value={phone}
                                        type="text"
                                        maxlength={10}
                                        // label="Enter phone number"
                                        onChange={(e: any) => {
                                            if (/^[0-9]+$/.test(e.target.value) || e.target.value === '') {
                                                this.onChangeHandler(e, 'phone');
                                            }
                                        }}
                                        error={this.state.phoneErr !== ''}
                                        helperText={this.state.phoneErr}
                                    />
                                    <div className="limit-div">
                                        {this.state.phoneLength}
                                        /10
                                    </div>
                                    <div className="inputFieldLabel">Previous Carrier</div>
                                    <SearchBoxWithDropdown
                                        dropdownList={ this.state.filteredCarrierList}
                                        optionLabel={(option: any) => option.displayName}
                                        value={carrier && carrier.displayName}
                                        onChange={this.searchChangeHandle}
                                        onTextFieldChange={this.carrierOnChange}
                                        onRequest={() => null}
                                    />
                                    {/* <Select
                                        value={carrier && carrier.value}
                                        options={carrierList}
                                        className="carrierDropDown"
                                        showDropDownIcon={true}
                                        // placeholder="Select Carrier"
                                        onChange={(e: any) => this.onChangeHandler(e, 'carrier')}
                                    /> */}
                                    <div className="errorText">{this.state.carrierErr}</div>
                                    {carrier && carrier.displayName === 'Other' ? (
                                        <>
                                            <div className="inputFieldLabel">Enter Carrier</div>
                                            <TextField
                                                value={otherCarrier}
                                                type="text"
                                                // label="Enter Carrier"
                                                onChange={(e: any) => {
                                                    if(/[^ ]/.test(e.target.value) || e.target.value === '')
                                                    this.onChangeHandler(e, 'others')
                                                }}
                                                error={this.state.otherCarrierErr !== ''}
                                                helperText={this.state.otherCarrierErr}
                                            />
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    <div className="inputFieldLabel">Previous Account Number</div>
                                    <TextField
                                        value={accountNumber}
                                        type="text"
                                        onChange={(e: any) => {
                                            if (/^[0-9]+$/.test(e.target.value) || e.target.value === '') {
                                                this.onChangeHandler(e, 'accountNumber');
                                            }
                                        }}
                                        error={this.state.accountNumberErr !== ''}
                                        helperText={this.state.accountNumberErr}
                                        maxlength={20}
                                    />
                                    <div className="inputFieldLabel">Previous Carrier PIN/Passcode</div>
                                    <TextField
                                        value={pin}
                                        type={'text'}
                                        onChange={(e: any) => {
                                            if (
                                                /[0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(e.target.value) ||
                                                e.target.value === ''
                                            ) {
                                                this.onChangeHandler(e, 'pin');
                                            }
                                        }}
                                        error={this.state.pinErr !== ''}
                                        helperText={this.state.pinErr}
                                        maxlength={16}
                                    />
                                    <div className="pinLabel">{carrier && carrier.pinLabel}</div>
                                    <div className="inputFieldLabel">ZIP Code</div>
                                    <TextField
                                        value={zipcode1}
                                        type="text"
                                        onChange={(e: any) => {
                                            if (/^[0-9]+$/.test(e.target.value) || e.target.value === '') {
                                                this.onChangeHandler(e, 'zipcode1');
                                            }
                                        }}
                                        error={
                                            this.state.zipErr !== '' ||
                                            (zipcode1 !== '' && (zipcode1 === '00000' || zipcode1 === '99999')) ||
                                            (zipcode1 !== '' && !/^\d{5,10}$/.test(zipcode1))
                                        }
                                        helperText={
                                            this.state.zipErr
                                                ? this.state.zipErr
                                                : zipcode1 !== '' && (zipcode1 === '00000' || zipcode1 === '99999')
                                                ? 'Invalid ZIP code. Please retry with a valid ZIP code.'
                                                : checkZipcodeClicked && !zipcode1
                                                ? 'Enter your billing zip code'
                                                : zipcode1 !== '' && !/^\d{5,10}$/.test(zipcode1)
                                                ? 'Enter valid zip code'
                                                : ''
                                        }
                                        maxlength={10}
                                    />
                                </div>
                                <div className="keepMyButton">
                                    <Button primary={true} onClick={!nextClicked ? this.nextHandler : ()=>{}} 
                                        disabled={
                                            !accountNumber || !pin || 
                                            !phone ||
                                            !carrier ||
                                            !zipcode1 || 
                                            (carrier && !carrier.displayName ) ||
                                            (carrier && carrier.displayName === 'Other' && !otherCarrier)
                                        }
                                    >
                                        {nextClicked ? (
                                            <div className="loaderCheck text-center">
                                                <CircularProgress />
                                            </div>
                                        ) : (
                                            'Next'
                                        )}
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                    {isFormData && (
                        <div className="bottomData">
                            {isFormData && carrier && carrier.acctNumMsg && carrier.pinMsg ? (
                                <div>
                                    <div className="infoByOperatorHeading">
                                        How to find your {carrier && carrier.displayName} account number and previous carrier
                                        PIN/Passcode
                                    </div>
                                    <div className="actPortingAccountBlk">
                                        <h4>Account Number</h4>
                                        <p className="infoByOperatorAccoutMsg">{carrier.acctNumMsg}</p>
                                    </div>
                                    <div className="actPortingAccountBlk">
                                        <h4>Previous Carrier PIN/Passcode</h4>
                                        <p className="infoByOperatorAccoutMsg">{`${carrier.pinMsg &&
                                            carrier.pinMsg.length > 4 &&
                                            carrier.pinMsg.replace('{0}', carrier.pinTel)} `}</p>
                                    </div>
                                    {carrier.extraPinInfo && (
                                        <div className="infoByOperatorTransferPin">
                                            <h4>
                                                To receive your previous carrier PIN/Passcode, follow the steps below*:
                                            </h4>
                                            <div className="actPortingAccordionBlk">
                                                {activationPage &&
                                                    activationPage.accordion.map((tab: any, index: string) => (
                                                        <Accordion>
                                                            <Accordion.Item eventKey={index}>
                                                                <Accordion.Header>
                                                                    {tab.label.replace('{0}', carrier && carrier.displayName)}
                                                                </Accordion.Header>
                                                                <Accordion.Body>
                                                                    {tab.description.map((item: any, index: number) => {
                                                                        return (
                                                                            <div key={index}>
                                                                                {item.replace(
                                                                                    '{0}',
                                                                                    carrier && carrier.displayName,
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        </Accordion>
                                                    ))}
                                            </div>
                                        </div>
                                    )}
                                    <div className="belowNote">
                                        *If you are a group member and someone within your group already generated a
                                        PIN/Passcode, use the same code.
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div className="actPortingAccountBlk">
                                        <h4>What is my previous carrier PIN/Passcode?</h4>
                                        <p className="infoByOperatorAccoutMsg">
                                            In order to transfer your number to Astound Mobile, you will need to provide
                                            a carrier PIN/Passcode (also called a Transfer PIN, Port-out PIN, Security
                                            PIN, etc.) either self-created or generted by your previous carrier. If a
                                            carrier PIN/Passcode is not provided, use 0000.
                                        </p>
                                    </div>
                                    <div className="actPortingAccountBlk">
                                        <h4>Having trouble finding your previous carrier info?</h4>
                                        <p className="infoByOperatorAccoutMsg">
                                            You can check your billing statement, contact your previous carrier, or as
                                            always,{' '}
                                            <span onClick={() => this.props.history.push('/help')}>
                                                contact us for support
                                            </span>
                                            .
                                        </p>
                                    </div>
                                </div>
                            )}

                            <div className="havePortingNeedHelpText">
                                <img src={helpPortIcon} alt="helpIcon" />
                                <a className="faqlink" target="_blank" href={this.state.faqUrl}>
                                    Have questions? Check out our FAQs
                                </a>
                            </div>
                            <div className="actPortingNeedHelpText">
                                <img src={chatIcon} alt="chatIcon" />
                                <span onClick={() => this.props.history.push('/help')}>
                                    Still need help? We’re always here!
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        PostActivationAction: bindActionCreators(PostActivationAction, dispatch),
        CheckoutActions: bindActionCreators(Action, dispatch),
        ActivationActions: bindActionCreators(ActivationAction, dispatch),
        BillingActions: bindActionCreators(BillingAction, dispatch),
        homeAction: bindActionCreators(HomeAction, dispatch),
    };
}

const mapStateToProps = (state: any) => ({
    PostActivationState: state.postActivation,
    BillingState: state.billing,
    CheckoutState: state.checkout,
    ActivationState: state.activation,
    homeState: state.home,
});

export default connect(mapStateToProps, mapDispatchToProps)(Step2);
